import React from 'react';
import { Layout, Menu } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { DashboardOutlined, ClockCircleOutlined, HistoryOutlined, TeamOutlined, CheckCircleOutlined, ProjectOutlined, CheckSquareOutlined, SettingOutlined } from '@ant-design/icons';
import Header from './Header';

const { Sider, Content } = Layout;

const ProjectManagerLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: '/project-manager',
      icon: <DashboardOutlined />,
      label: 'PM Dashboard',
      onClick: () => navigate('/project-manager')
    },
    {
      key: '/project-manager/projects',
      icon: <ProjectOutlined />,
      label: 'My Projects',
      onClick: () => navigate('/project-manager/projects')
    },
    {
      key: '/project-manager/tasks',
      icon: <SettingOutlined />,
      label: 'Task Management',
      onClick: () => navigate('/project-manager/tasks')
    },
    {
      key: '/project-manager/my-tasks',
      icon: <CheckSquareOutlined />,
      label: 'My Tasks',
      onClick: () => navigate('/project-manager/my-tasks')
    },
    {
      key: '/project-manager/timesheet',
      icon: <ClockCircleOutlined />,
      label: 'Submit Timesheet',
      onClick: () => navigate('/project-manager/timesheet')
    },
    {
      key: '/project-manager/approvals',
      icon: <CheckCircleOutlined />,
      label: 'Approve Timesheets',
      onClick: () => navigate('/project-manager/approvals')
    },
    {
      key: '/project-manager/team',
      icon: <TeamOutlined />,
      label: 'Team Overview',
      onClick: () => navigate('/project-manager/team')
    },
    {
      key: '/project-manager/history',
      icon: <HistoryOutlined />,
      label: 'View History',
      onClick: () => navigate('/project-manager/history')
    }
  ];

  const selectedKey = location.pathname;

  return (
    <Layout className="min-h-screen">
      <Header />
      <Layout>
        <Sider 
          width={250} 
          className="bg-white border-r border-gray-200"
          theme="light"
        >
          <div className="p-4">
            <h3 className="text-lg font-semibold text-purple-800 mb-4">One Qodequay</h3>
          </div>
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            className="border-r-0"
            style={{
              height: 'calc(100vh - 120px)',
              borderRight: 0,
            }}
          />
        </Sider>
        <Content className="flex-1 bg-gray-50">
          <div className="p-6">
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ProjectManagerLayout;
